import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Recarrega automaticamente em erro de chunk obsoleto (após novo deploy)
    const msg = String(error?.message || error || '');
    if (/ChunkLoadError|Loading chunk|dynamically imported module/i.test(msg)) {
      if (!sessionStorage.getItem('kn_chunk_reloaded')) {
        sessionStorage.setItem('kn_chunk_reloaded', '1');
        window.location.reload();
        return;
      }
    }
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary capturou:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null, info: null });
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/dashboard';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const message = String(this.state.error?.message || this.state.error || 'Erro desconhecido');
    return (
      <div
        className="min-h-screen bg-gray-50 flex items-center justify-center p-6"
        data-testid="app-error-boundary"
      >
        <div className="max-w-md w-full bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-rose-50 text-rose-600 text-2xl">
            !
          </div>
          <h1 className="text-lg font-semibold text-gray-900 mb-1">Algo deu errado</h1>
          <p className="text-sm text-gray-500 mb-4">
            Ocorreu um erro ao exibir esta tela. Você pode recarregar e continuar usando o sistema.
          </p>
          <div className="flex gap-2 justify-center">
            <button
              onClick={this.handleReload}
              className="px-4 py-2 rounded-md bg-[#003366] text-white text-sm font-semibold hover:bg-[#002244] transition-colors"
              data-testid="error-reload-btn"
            >
              Recarregar
            </button>
            <button
              onClick={this.handleHome}
              className="px-4 py-2 rounded-md bg-white border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors"
              data-testid="error-home-btn"
            >
              Ir para o início
            </button>
          </div>
          <details className="mt-4 text-left">
            <summary className="text-xs text-gray-400 cursor-pointer">Detalhes técnicos</summary>
            <pre className="mt-2 max-h-40 overflow-auto rounded bg-gray-50 p-2 text-[11px] text-gray-600 whitespace-pre-wrap break-words">
              {message}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
